import { DataManager } from '@syncfusion/ej2-data';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RecordDoubleClickEventArgs, RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { ExportInterfaceActivationEmailTemplateDTO } from 'src/app/base/models/models.swagger.generated';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ActivationEmailTemplatesOverviewService } from './activation-email-templates-overview.service';
import { UntypedFormGroup } from '@angular/forms';
import { ModalService } from '../../../../base/shared/modal/modal.service';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-activation-email-templates-overview',
    templateUrl: './activation-email-templates-overview.component.html',
    styleUrls: ['./activation-email-templates-overview.component.scss'],
    imports: [
        GridModule,
        QueryBuilderModule,
        TranslateModule,
    ]
})
export class ActivationEmailTemplatesOverviewComponent extends GridBaseComponent<any> implements OnInit {
  @Output() rowSelected = new EventEmitter<ExportInterfaceActivationEmailTemplateDTO>();
  @Output() recordDoubleClick = new EventEmitter<ExportInterfaceActivationEmailTemplateDTO>();

  @Input() public activationEmailTemplateForm: UntypedFormGroup;
  @Input() public set selectedActivationEmailTemplateId(value: number) {
    if (value !== this._selectedActivationEmailTemplateId) {
      this._selectedActivationEmailTemplateId = value;
      if (value !== null && value !== undefined) {
        this.grid?.selectRows([this.grid.getRowIndexByPrimaryKey(value)]);
      } else {
        this.grid?.selectRows([]);
      }
    }
  }

  private addedRecordId: number = null;
  private previousRowIndex: number;
  private _selectedActivationEmailTemplateId: number;

  constructor(
    translateService: TranslateService,
    protected templatesService: ActivationEmailTemplatesOverviewService,
    private spinnerService: SpinnerService,
    private modalService: ModalService,
  ) {
    super(translateService, templatesService);
  }

  ngOnInit() {
    this.isActiveColumnName = 'Active';
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.templatesService, this.spinnerService),
    });
    this.templatesService.oneTimeFilterTemplateId = this._selectedActivationEmailTemplateId;
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    if (this.activationEmailTemplateForm?.dirty) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.activation-email-templates.discard-dialog.title', 'i18n.domain.export-configuration.activation-email-templates.discard-dialog.question');
      dialog.onOkSubject.subscribe(() => {
        const data = args.data as ExportInterfaceActivationEmailTemplateDTO;
        if (data) {
          this._selectedActivationEmailTemplateId = data.id;
          this.rowSelected.emit(data);
          this.previousRowIndex = this.grid?.selectedRowIndex;
        }
      });
      dialog.onCancelSubject.subscribe(() => {
        this.grid.selectRows([this.previousRowIndex]);
      });
    } else {
      const data = args.data as ExportInterfaceActivationEmailTemplateDTO;
      if (data) {
        this._selectedActivationEmailTemplateId = data.id;
        this.rowSelected.emit(data);
        this.previousRowIndex = this.grid?.selectedRowIndex;
      }
    }
  }

  public onRecordDoubleClick(args: RecordDoubleClickEventArgs): void {
    const data = args.rowData as ExportInterfaceActivationEmailTemplateDTO;
    if (data) {
      this.recordDoubleClick.emit(data);
    }
  }

  public recordAdded(id: number) {
    this.addedRecordId = id;
    this.grid.refresh();
  }

  public onDataBound() {
    if (this.addedRecordId) {
      const index = this.grid?.getRowIndexByPrimaryKey(this.addedRecordId);
      this.grid?.selectRow(index);
      this.addedRecordId = null;
      if (this.previousRowIndex >= index) {
        this.previousRowIndex += 1;
      }
    }

    if (this._selectedActivationEmailTemplateId && this.grid?.selectedRowIndex < 0) {
      const index = this.grid?.getRowIndexByPrimaryKey(this._selectedActivationEmailTemplateId);
      this.grid?.selectRow(index);
    }
  }

  public refresh(): void {
    this.grid.refresh();
  }

  public resetRowSelected(): void {
    if (this.grid?.selectedRowIndex >= 0) {
      this.grid.selectRows([]);
    }
  }

  protected initializeEditForm(data: ExportInterfaceActivationEmailTemplateDTO): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

}
